import type { AxiosRequestConfig } from "axios";
import type { GranularCatalogConfig } from "@granular/fabric-catalog-helpers";
import merge from "lodash/merge";

import enrollment from "./enrollment";
import field from "./enrollment/field";

export type EnrollmentsSvcLambdaInstance = {
  getEnrollments: (
    params: Parameters<typeof enrollment.GET>[0],
    axiosRequestConfig?: AxiosRequestConfig,
  ) => ReturnType<typeof enrollment.GET>;
  /**
   * @deprecated Use getEnrollments instead
   */
  getEnrollmentsNonLambda: (
    params: Parameters<typeof enrollment.nonLambda.GET>[0],
    axiosRequestConfig?: AxiosRequestConfig,
  ) => ReturnType<typeof enrollment.nonLambda.GET>;
  getFieldEnrollments: (
    axiosRequestConfig?: AxiosRequestConfig,
  ) => ReturnType<typeof field.GET>;
  enrollFields: (
    enrollment: Parameters<typeof field.POST>[0],
    axiosRequestConfig?: AxiosRequestConfig,
  ) => ReturnType<typeof field.POST>;
};

const createEnrollmentsSvcLambdaInstance = (
  catalogConfig: GranularCatalogConfig,
  instanceRequestConfig?: AxiosRequestConfig,
): EnrollmentsSvcLambdaInstance => ({
  getEnrollments: (params, axiosRequestConfig) =>
    enrollment.GET(
      params,
      catalogConfig,
      merge(instanceRequestConfig, axiosRequestConfig),
    ),
  /**
   * @deprecated Use getEnrollments instead
   */
  getEnrollmentsNonLambda: (params, axiosRequestConfig) =>
    enrollment.nonLambda.GET(
      params,
      catalogConfig,
      merge(instanceRequestConfig, axiosRequestConfig),
    ),
  getFieldEnrollments: (axiosRequestConfig) =>
    field.GET(catalogConfig, merge(instanceRequestConfig, axiosRequestConfig)),
  enrollFields: (enrollment, axiosRequestConfig) =>
    field.POST(
      enrollment,
      catalogConfig,
      merge(instanceRequestConfig, axiosRequestConfig),
    ),
});

export default createEnrollmentsSvcLambdaInstance;
